/**
 * Gets the domain name from the given path.
 * e.g. `categories.home` => `categories`
 * @param  {string} path
 * @returns {string}
 */
function getDomainPathFromPathReduxUtil (path) {
  if (path && path.includes('.')) {
    path = path.slice(0, path.indexOf('.'))
  }
  return path
}

export default getDomainPathFromPathReduxUtil
